/* eslint-disable @nx/enforce-module-boundaries */
import fetchChecksums, { Checksum } from "@jnctn/api/app/fetchChecksums";
import { useAsyncResource } from "use-async-resource";
import useUser from "./useUser";

export function useAccessToken(): string | undefined {
  return useUser()?.access_token;
}

export function useChecksums(): Array<Checksum> {
  const [checksumsReader] = useAsyncResource(fetchChecksums, useAccessToken());
  return checksumsReader();
}
